export default "__VITE_ASSET__JNXAmOiL__"